import { mdiAccountCreditCardOutline, mdiAccountKey, mdiCalendarImport, mdiCashMultiple, mdiChartBoxOutline, mdiChartMultiple, mdiFinance, mdiFlaskOutline, mdiForklift, mdiMonitorArrowDown, mdiPackageVariant, mdiPaletteSwatch, mdiStorageTankOutline, mdiStrategy, mdiSwapHorizontalHidden, mdiTuneVertical, mdiWarehouse } from "@mdi/js";

export const ARCHEM_APPS = {
  TANK_SOUNDING: {
    module_name: 'Tank Sounding',
    title: 'Tank Sounding',
    description: 'Manage Customer Deliveries, Supplier Monitoring',
    url: '/tanksounding',
    iconPath: mdiStorageTankOutline,
    enabled: false
  },
  LOGISTICS: {
    module_name: 'Logistics',
    title: 'Logistics',
    description: 'Manage Customer Deliveries, Supplier Monitoring',
    url: '/logistics',
    iconPath: mdiForklift,
    enabled: false
  },
  RAW_MATS: {
    module_name: 'Purchasing Raw Mats',
    title: 'Purchase Contract  Raw Materials',
    description: '',
    url: '/rawmats',
    iconPath: mdiPackageVariant,
    enabled: false
  },
  NON_RAW_MATS: {
    module_name: 'Purchasing',
    title: 'Purchase Contract Non-Raw Materials, Job Contract',
    description: '',
    url: '/nonrawmats',
    iconPath: mdiPaletteSwatch,
    enabled: false
  },
  SALES_CONTRACT: {
    module_name: 'Sales Order',
    title: 'Sales Contract',
    description: 'Create/maintain customer sales contract',
    url: '/salescontract',
    iconPath: mdiCashMultiple,
    enabled: false
  },
  INTERPLANT: {
    module_name: 'Interplant Transfer',
    title: 'Inter Plant Transfer',
    description: '',
    url: '/interplanttransfer',
    iconPath: mdiSwapHorizontalHidden,
    enabled: false
  },
  TRADE_SUMMARY: {
    module_name: 'Trade Summary',
    title: 'Trade Summary',
    description: 'Sales and purchase trade summary',
    url: '/tradesummary',
    iconPath: mdiFinance,
    enabled: false
  },
  UCAP: {
    module_name: 'UCAP',
    title: 'UCAP',
    description: 'CME Pricing',
    url: '/ucap',
    iconPath: mdiChartMultiple,
    enabled: false
  },
  RACO: {
    module_name: 'RACO Price',
    title: 'RACO Price',
    description: 'CNO Price Monitoring',
    url: '/raco',
    iconPath: mdiStrategy,
    enabled: false
  },
  EXPORT_MONITORING: {
    module_name: 'Export Monitoring',
    title: 'Export Monitoring',
    description: 'Sales contract checklist per booking confirmation',
    url: '/exportmonitoring',
    iconPath: mdiMonitorArrowDown,
    enabled: false
  },
  IMPORT_MONITORING: {
    module_name: 'Import Monitoring',
    title: 'Import Monitoring',
    description: 'Purchase order checklist per booking confirmation',
    url: '/importmonitoring',
    iconPath: mdiCalendarImport,
    enabled: false
  },
  DAILY_PRODUCTION_REPORT: {
    module_name: 'Daily Production Report',
    module_desc: 'DPR',
    title: 'Daily Production Report',
    description: '',
    url: '/dpr',
    iconPath: mdiChartBoxOutline,
    enabled: false
  },
  PAYROLL: {
    title: 'Payroll',
    description: 'Payroll Processing',
    url: '',
    iconPath: mdiAccountCreditCardOutline,
    enabled: false
  },
  LABORATORY: {
    title: 'Laboratory',
    description: '',
    url: '',
    iconPath: mdiFlaskOutline,
    enabled: false
  },
  WAREHOUSE: {
    title: 'Warehouse',
    description: '',
    url: '',
    iconPath: mdiWarehouse,
    enabled: false
  },
  USER_MAINTENANCE: {
    module_name: 'User Maintenance',
    title: 'User Maintenance',
    description: 'Set user access and permissions.',
    url: '/archemusers',
    iconPath: mdiAccountKey,
    enabled: false
  },
  SETTINGS: {
    module_name: 'System Settings',
    title: 'Settings',
    description: 'System Settings.',
    url: '/maintenance',
    iconPath: mdiTuneVertical,
    enabled: false
  }

}